import React from 'react';
import { Routes, Route } from 'react-router-dom';
import EunoiaPage from './pages/EunoiaPage';

const EunoiaRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<EunoiaPage />} />
    </Routes>
  );
};

export default EunoiaRoutes;
